import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { ZoomInButton, ZoomOutButton } from '@sas/react-svg';
import { Button, ButtonVariant } from '@sas/nova-commons/components/Button';
import { useI18n } from '../../locale/I18nContext';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import cn from './ZoomToolbar.css.json';
import './ZoomToolbar.css';
export const ZoomToolbar = (props) => {
    const localize = useI18n();
    const dt = useDesignTokens();
    const [focusedIndex, setFocusedIndex] = useState(0);
    const refZoomIn = useRef(null);
    const refZoomOut = useRef(null);
    const refContainer = useRef(null);
    useEffect(() => {
        var _a, _b, _c;
        if (!((_a = refContainer.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement))) {
            return;
        }
        if (focusedIndex === 0) {
            (_b = refZoomIn.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else {
            (_c = refZoomOut.current) === null || _c === void 0 ? void 0 : _c.focus();
        }
    }, [focusedIndex]);
    return (_jsxs("div", Object.assign({ ref: refContainer, className: cn.container, role: "toolbar", style: renderInlineCssVars(ZoomToolbarTokens(dt), 'zoom'), onKeyDown: (e) => {
            let handled = true;
            switch (e.key) {
                case 'ArrowUp':
                case 'ArrowLeft':
                case 'ArrowDown':
                case 'ArrowRight':
                    setFocusedIndex((i) => (i === 1 ? 0 : 1));
                    break;
                case 'PageUp':
                case 'Home':
                    setFocusedIndex(0);
                    break;
                case 'PageDown':
                case 'End':
                    setFocusedIndex(1);
                    break;
                default:
                    handled = false;
            }
            if (handled) {
                e.preventDefault();
            }
        }, onFocus: (e) => {
            var _a, _b;
            if ((_a = refZoomIn.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
                setFocusedIndex(0);
            }
            else if ((_b = refZoomOut.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)) {
                setFocusedIndex(1);
            }
        } }, { children: [_jsx(Button, { ref: refZoomIn, className: cn.button, variant: ButtonVariant.Icon, icon: { icon: ZoomInButton }, onPress: props.onZoomIn, disabled: !props.canZoomIn, tooltip: localize({ key: 'ZoomControl.button.zoomin.txt' }), focusable: focusedIndex === 0 }), _jsx(Button, { ref: refZoomOut, className: cn.button, variant: ButtonVariant.Icon, icon: { icon: ZoomOutButton }, onPress: props.onZoomOut, disabled: !props.canZoomOut, tooltip: localize({ key: 'ZoomControl.button.zoomout.txt' }), focusable: focusedIndex === 1 })] })));
};
function ZoomToolbarTokens(dt) {
    return {
        bd: dt.reportTokens.stateStandard.normal.bd,
        bg: dt.reportTokens.backgrounds.page.bg,
    };
}
